"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _core = require("@emotion/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _envConstants = require("../constants/envConstants");

var _useShipmentPlan2 = _interopRequireDefault(require("../hooks/useShipmentPlan"));

var _CenteredSpinner = _interopRequireDefault(require("./CenteredSpinner"));

var _ShipmentHeader = _interopRequireDefault(require("./ShipmentHeader"));

var _ShipmentPlanError = _interopRequireDefault(require("./ShipmentPlanError"));

var _ShipmentPlanInfo = _interopRequireDefault(require("./ShipmentPlanInfo"));

var _ErrorDisplay = _interopRequireDefault(require("./displays/ErrorDisplay"));

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var planDisplayStyle = process.env.NODE_ENV === "production" ? {
  name: "15n7dyy-planDisplayStyle",
  styles: "max-width:900px;h3{font-weight:600;margin:0;};label:planDisplayStyle;"
} : {
  name: "15n7dyy-planDisplayStyle",
  styles: "max-width:900px;h3{font-weight:600;margin:0;};label:planDisplayStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var ShipmentPlanViewer = function ShipmentPlanViewer(_ref) {
  var className = _ref.className,
      style = _ref.style,
      shipmentPlanUrl = _ref.shipmentPlanUrl,
      env = _ref.env,
      accessToken = _ref.accessToken;

  var _useShipmentPlan = (0, _useShipmentPlan2["default"])({
    shipmentPlanUrl: shipmentPlanUrl,
    accessToken: accessToken
  }),
      isLoadingPlanData = _useShipmentPlan.isLoading,
      isPlanDataError = _useShipmentPlan.isError,
      shipmentPlanData = _useShipmentPlan.data,
      error = _useShipmentPlan.error;

  var deliveryRequestUrl = (0, _get2["default"])(shipmentPlanData, 'shipmentPlanData._links.deliveryRequest.href');

  if (isLoadingPlanData) {
    return (0, _core.jsx)(_CenteredSpinner["default"], null);
  }

  if (isPlanDataError || !shipmentPlanData) {
    if ((0, _get2["default"])(error, 'response.status') === 403 || (0, _get2["default"])(error, 'response.body.details.clientStatusCode') === 403) {
      return (0, _core.jsx)(_ErrorDisplay["default"], {
        errorMsg: "You don't have the correct permissions to see the plan."
      });
    }

    return (0, _core.jsx)(_ErrorDisplay["default"], {
      errorMsg: "Something went wrong. Please refresh the page and try again."
    });
  }

  var shipmentPlanErrors = (0, _get2["default"])(shipmentPlanData, 'shipmentPlanData.errors');
  return (0, _core.jsx)("div", {
    className: className,
    style: style,
    css: planDisplayStyle
  }, (0, _core.jsx)(_ShipmentHeader["default"], null, function (_ref2) {
    var showShipRecRequest = _ref2.showShipRecRequest,
        setShowRequestButton = _ref2.setShowRequestButton;
    return (0, _isEmpty2["default"])(shipmentPlanErrors) ? (0, _core.jsx)(_ShipmentPlanInfo["default"], {
      shipmentPlan: shipmentPlanData,
      showShipRecRequest: showShipRecRequest,
      setShowRequestButton: setShowRequestButton,
      accessToken: accessToken,
      env: env
    }) : (0, _core.jsx)(_ShipmentPlanError["default"], {
      failedPlans: [shipmentPlanData.shipmentPlanData],
      deliveryRequestUrl: deliveryRequestUrl,
      showShipRecRequest: showShipRecRequest,
      setShowRequestButton: setShowRequestButton,
      accessToken: accessToken,
      env: env
    });
  }));
};

ShipmentPlanViewer.propTypes = {
  className: _propTypes["default"].string,
  style: _reactStyleProptype["default"],
  accessToken: _propTypes["default"].string.isRequired,
  shipmentPlanUrl: _propTypes["default"].string.isRequired,
  env: _propTypes["default"].oneOf([_envConstants.PRD, _envConstants.INT])
};
ShipmentPlanViewer.defaultProps = {
  className: undefined,
  style: undefined,
  env: _envConstants.PRD
};
var _default = ShipmentPlanViewer;
exports["default"] = _default;